import { render, staticRenderFns } from "./SummaryOuter.vue?vue&type=template&id=88f4756c&scoped=true"
import script from "./SummaryOuter.vue?vue&type=script&lang=js"
export * from "./SummaryOuter.vue?vue&type=script&lang=js"
import style0 from "./SummaryOuter.vue?vue&type=style&index=0&id=88f4756c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88f4756c",
  null
  
)

export default component.exports